import React from 'react';
import { Card } from '@brokerbay/design-components';
import styled from 'styled-components';

const CurrentBenefitsCard: React.FC = () => (
  <StyledCard title="Current Benefits" withContent={false}>
    {/* Current benefits content will go here */}
  </StyledCard>
);

export default CurrentBenefitsCard;

export const StyledCard = styled(Card)<{ withContent?: boolean }>`
  ${({ withContent }) =>
    withContent &&
    `.ant-card-body {
    padding: 1px 0px;
  }`}
`;
